import {createSlice} from '@reduxjs/toolkit'

export const actionsHint = createSlice({
  name: 'actionsHint',
  initialState: {
    showedTimes: 0,
  },
  reducers: {
    recordShowed(state) {
      state.showedTimes++
    },
  },
})
